import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
    ExpandablePageGuidedWorkflows,
    GuidedWorkflowStep,
    GuidedWorkflowSubcategory,
} from 'GuidedWorkflowsApp/ts/interfaces/guided-workflows.response';

/**
 *
 * Guided Workflows Categories Component
 *  Displays expandeable categories and subcategories of guided workflows.
 *  Clicking a subcategory should display steps content instead.
 *
 * Input Properties:
 *   expandableCategories: list of ExpandablePageGuidedWorkflows to display.
 *   steps: list of GuidedWorkflowStep to display.
 *   selectedCategory: Expanded category

 *
 * Output Properties:
 *   stepsChange: EventEmitter to emit the steps.
 *   selectedCategoryChange: EventEmitter to emit the selected category.
 *   selectedSubcategory: EventEmitter to emit the selected subcategory.
 *
 */
@Component({
    standalone: false,
    selector: 'ycn-guided-workflows-categories',
    templateUrl: './guided-workflows-categories.template.html',
})
export class GuidedWorkflowsCategoriesComponent {
    @Input({ required: true }) expandableCategories: ExpandablePageGuidedWorkflows[] = [];

    @Input({ required: true }) steps!: GuidedWorkflowStep[];

    @Input() selectedCategory: ExpandablePageGuidedWorkflows | null = null;

    @Output() stepsChange: EventEmitter<GuidedWorkflowStep[]> = new EventEmitter<GuidedWorkflowStep[]>();

    @Output() selectedCategoryChange: EventEmitter<ExpandablePageGuidedWorkflows> =
        new EventEmitter<ExpandablePageGuidedWorkflows>();

    @Output() selectedSubcategory: EventEmitter<GuidedWorkflowSubcategory> =
        new EventEmitter<GuidedWorkflowSubcategory>();

    toggleCategory(category: ExpandablePageGuidedWorkflows): void {
        // eslint-disable-next-line no-param-reassign
        category.expanded = !category.expanded;
        this.selectedCategoryChange.emit(category);
    }

    selectSteps(category: ExpandablePageGuidedWorkflows, subcategory: GuidedWorkflowSubcategory): void {
        this.selectedCategoryChange.emit(category);
        this.selectedSubcategory.emit(subcategory);
        this.stepsChange.emit(subcategory.steps);
    }
}
